<template>
  <div style="height: 50px;padding-top: 10px;margin-top: -30px;">
    <div class="title-left" style="display: flex;">
      <div class="show-title all-three-point">
        <img v-if="urlShow === 1" class="left-logo" src="../../../assets/logo/ryhf.png">
        <span class="text-color" style="font-family: CustomFont;font-size: 24px" v-if="showTitle === '上海市嘉定区委老干部局'">{{showTitle}}</span>
        <span class="text-color" style="font-family: CustomFont;" v-else-if="showTitle === '智慧养老系统'">
          <span v-if="$store.state.user.LoginResp.system_name && $store.state.user.LoginResp.system_name !== ''">{{$store.state.user.LoginResp.system_name}}</span>
          <span :style="{fontSize: showTitle.length > 8 ? '26px' : ''}" v-else>{{showTitle}}</span>
        </span>
        <span class="text-color" style="font-family: CustomFont;" v-else>{{showTitle}}</span>
      </div>
    </div>
    <div class="nav-right-list">
      <div class="item-nav" :class="indexActive === item.id ? 'active-select' : ''" v-for="item in menuList" :key="item.index" @click="changeMenu(item)">
        <span>{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'jujiaNav',
  data () {
    return {
      urlShow: 0, // 1、荣逸集团 0、其他
      showTitle: '智慧养老系统',
      indexActive: 1,
      menuList: [ // id 到 45
        {id: 1, path: '/monitor', title: '运营看板', arr: []},
        {
          id: 2,
          title: '处理中心',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              lists: [
                {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                // {id: 3, level1: 2, path: '/customerService', name: '客服关爱', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}, // 上海独有
                {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            }
          ]
        },
        {
          id: 3,
          title: '系统管理',
          arr: [
            {
              path: '',
              name: '基础管理',
              isOpen: true,
              icon: '/static/menuIcon/a_jc.png',
              lists: [
                {id: 6, level1: 3, path: '/organization', name: '组织管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 7, level1: 3, path: '/user', name: '员工管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 8, level1: 3, path: '/account', name: '账号管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '其他设置',
              isOpen: true,
              icon: '/static/menuIcon/a_shezhi.png',
              lists: [
                {id: 13, level1: 3, path: '/SIPphone', name: '呼叫中心管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 14, level1: 3, path: '/project', name: '项目管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            }
          ]
        },
        {
          id: 8,
          title: '服务管理',
          arr: [
            {
              path: '',
              name: '服务订单',
              isOpen: true,
              icon: '/static/menuIcon/a_jichu.png',
              lists: [
                {id: 2, level1: 8, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 39, level1: 8, path: '/examineOrder', name: '订单审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 50, level1: 8, path: '/servicePackage', name: '服务包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 51, level1: 8, path: '/serviceProjectBundle', name: '服务项目包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '服务设置',
              isOpen: true,
              icon: '/static/menuIcon/a_shuju.png',
              lists: [
                {id: 37, level1: 8, path: '/supplierTypeService', name: '服务类型', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 38, level1: 8, path: '/supplierContent', name: '服务内容', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 9, level1: 8, path: '/supplierType', name: '服务商管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 11, level1: 8, path: '/serviceUser', name: '服务商人员管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                // {id: 12, level1: 8, path: '/frequency', name: '服务频率设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '日常运营',
              isOpen: true,
              icon: '/static/menuIcon/a_shuju.png',
              lists: [
                {id: 43, level1: 8, path: '/activityManagement', name: '活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            }
          ]
        },
        {
          id: 4,
          title: '数据管理',
          arr: [
            {
              path: '',
              name: '基础数据',
              isOpen: true,
              icon: '/static/menuIcon/a_jichu.png',
              lists: [
                {id: 15, level1: 4, path: '/community', name: this.$store.state.user.moduletag === 3 ? '小区/机构管理' : '小区管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 16, level1: 4, path: '/homeManagement', name: this.$store.state.user.moduletag === 3 ? '家庭/房间管理' : '家庭管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 17, level1: 4, path: '/serviceObject', name: '服务对象管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '数据维护',
              isOpen: true,
              icon: '/static/menuIcon/a_shuju.png',
              lists: [
                {id: 18, level1: 4, path: '/checkData', name: '数据审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 41, level1: 4, path: '/chargeReminder', name: '费用管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            }
          ]
        },
        {
          id: 5,
          title: '智慧物联',
          arr: [
            {
              path: '',
              name: '设备管理',
              isOpen: true,
              icon: '/static/menuIcon/a_guangli.png',
              lists: [
                {id: 19, level1: 5, path: '/device', name: '监护设备', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 44, level1: 5, path: '/deviceStaff', name: '员工设备', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 45, level1: 5, path: '/deviceSupplier', name: '服务商人员设备', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '设备交互',
              isOpen: false,
              icon: '/static/menuIcon/a_jh.png',
              lists: [
                {id: 20, level1: 5, path: '/deviceSet', name: '批量设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 21, level1: 5, path: '/voiceNotification', name: '语音通知', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 22, level1: 5, path: '/deviceGroupChat', name: '设备群聊', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '',
              isOpen: true,
              icon: '',
              lists: [
                {id: 23, level1: 5, path: '/healthData', name: '健康数据', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 24, level1: 5, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                // {id: 42, level1: 5, path: '/safetyActivity', name: '消防活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
              ]
            }
          ]
        },
        {
          id: 6,
          title: '报表统计',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              icon: '',
              lists: [
                {id: 25, level1: 6, path: '/alarmService', name: '事件统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            },
            {
              path: '',
              name: '服务统计',
              isOpen: true,
              icon: '/static/menuIcon/a_fw.png',
              lists: [
                {id: 26, level1: 6, path: '/serviceEvent', name: '服务日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            }
          ]
        }
      ]
    }
  },
  created () {
    this.getStartLists()
    this.golobleObject.getChangeTab = this.getChangeTab // 点击orgNavWrap切换
    this.golobleObject.getGoCheck = this.changeIndex
    this.golobleObject.changeMoney = this.clickMoney
    this.indexActive = this.$store.getters.get_is_indexActive
    let scene = this.$store.state.user.scene
    let currentHost = window.location.host
    // jiaold.cn / jiaold.com 是中性域名，强制使用中性标题
    let isNeutralDomain = currentHost === 'jiaold.com' || currentHost === 'www.jiaold.com' ||
      currentHost === 'jiaold.cn' || currentHost === 'www.jiaold.cn'
    if (isNeutralDomain || scene !== 0) {
      this.showTitle = '智慧养老系统'
    } else {
      // 登录返回 mqtt 中，包含 "/1/14/1323" 这个topic ，判断为老干局，需要显示老干局的监控页面
      let aa = '/1/14/1323'
      let isWeiNing = this.$store.state.user.mqtts.indexOf(aa) === -1
      if (isWeiNing) {
        this.showTitle = '慰宁健康智慧养老'
      } else {
        this.showTitle = '上海市嘉定区委老干部局'
      }
    }
    let aa = window.location.host
    if (aa === 'ryhf.jiaold.com') {
      this.urlShow = 1
    } else {
      this.urlShow = 0
    }
  },
  mounted () {
    this.getLists() // 刷新
  },
  methods: {
    getStartLists () {
      let urlLine = window.location.host
      let role = this.$store.state.user.role
      if (role === 'superadmin' || role === 'admin') {
        //  newjky.wecare-u.net域名下且登录账号的mqttlevel 是 /1/14时，才显示页面 - SIM卡充值状态
        let bb = '/1/14'
        let isShow = false
        console.log('urlLine', urlLine)
        if (urlLine === 'newjky.wecare-u.net' || urlLine === 'newhealth.wecare-u.net' || urlLine === 'kangnh.com' ||
          urlLine === 'kangnh.com' || urlLine === 'bengshan.kangnh.com' || urlLine === 'localhost:8080') { // 上海更改
          isShow = this.$store.state.user.mqtts.indexOf(bb) > -1
          let nav = {
            id: 2,
            title: '处理中心',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                lists: [
                  {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 3, level1: 2, path: '/customerService', name: '客服关爱', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}, // 上海独有
                  {id: 4, level1: 2, path: '/activeService', name: '发起服务', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  // {id: 42, level1: 5, path: '/safetyActivity', name: '消防活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  // {id: 43, level1: 5, path: '/activityManagement', name: '活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          let nav1 = {
            id: 6,
            title: '报表统计',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                icon: '',
                lists: [
                  {id: 25, level1: 6, path: '/alarmService', name: '事件统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '服务统计',
                isOpen: true,
                icon: '/static/menuIcon/a_fw.png',
                lists: [
                  {id: 26, level1: 6, path: '/serviceEvent', name: '服务日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 27, level1: 6, path: '/callPhone', name: '客服关爱统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}, // 上海独有
                  {id: 28, level1: 6, path: '/otherStatistics', name: '计生法律统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}, // 上海独有
                  {id: 29, level1: 6, path: '/outworkStatistics', name: '外勤客服统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'} // 上海独有
                ]
              },
              {
                path: '',
                name: '呼叫中心',
                isOpen: true,
                icon: '/static/menuIcon/a_hj.png',
                lists: [
                  {id: 30, level1: 6, path: '/seatsOnline', name: '坐席在线统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 31, level1: 6, path: '/callInfo', name: '呼叫信息统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          let nav2 = {
            id: 3,
            title: '系统管理',
            arr: [
              {
                path: '',
                name: '基础管理',
                isOpen: true,
                icon: '/static/menuIcon/a_jc.png',
                lists: [
                  {id: 6, level1: 3, path: '/organization', name: '组织管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 7, level1: 3, path: '/user', name: '员工管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 8, level1: 3, path: '/account', name: '账号管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '其他设置',
                isOpen: true,
                icon: '/static/menuIcon/a_shezhi.png',
                lists: [
                  {id: 13, level1: 3, path: '/SIPphone', name: '呼叫中心管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 32, level1: 3, path: '/stateRefillCard', name: 'SIM卡充值状态', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}, // 上海独有
                  {id: 14, level1: 3, path: '/project', name: '项目管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          let nav3 = {
            id: 8,
            title: '服务管理',
            arr: [
              {
                path: '',
                name: '服务订单',
                isOpen: true,
                icon: '/static/menuIcon/a_jichu.png',
                lists: [
                  {id: 2, level1: 8, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 39, level1: 8, path: '/examineOrder', name: '订单审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 50, level1: 8, path: '/servicePackage', name: '服务包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 51, level1: 8, path: '/serviceProjectBundle', name: '服务项目包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '服务设置',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 37, level1: 8, path: '/supplierTypeService', name: '服务类型', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 38, level1: 8, path: '/supplierContent', name: '服务内容', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 9, level1: 8, path: '/supplierType', name: '服务商管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 11, level1: 8, path: '/serviceUser', name: '服务商人员管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  // {id: 12, level1: 8, path: '/frequency', name: '服务频率设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '日常运营',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 43, level1: 8, path: '/activityManagement', name: '活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '小程序业务',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 46, level1: 8, path: '/userManagement', name: '注册用户', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 47, level1: 8, path: '/projectSet', name: '项目设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  // {id: 48, level1: 8, path: '/pointsSet', name: '积分设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  // {id: 49, level1: 8, path: '/pointsDetails', name: '积分详情', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          if (urlLine === 'kangnh.com') { // 去掉服务频率
            nav3 = {
              id: 8,
              title: '服务管理',
              arr: [
                {
                  path: '',
                  name: '服务订单',
                  isOpen: true,
                  icon: '/static/menuIcon/a_jichu.png',
                  lists: [
                    {id: 2, level1: 8, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 39, level1: 8, path: '/examineOrder', name: '订单审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 50, level1: 8, path: '/servicePackage', name: '服务包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 51, level1: 8, path: '/serviceProjectBundle', name: '服务项目包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  ]
                },
                {
                  path: '',
                  name: '服务设置',
                  isOpen: true,
                  icon: '/static/menuIcon/a_shuju.png',
                  lists: [
                    {id: 37, level1: 8, path: '/supplierTypeService', name: '服务类型', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 38, level1: 8, path: '/supplierContent', name: '服务内容', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 9, level1: 8, path: '/supplierType', name: '服务商管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 11, level1: 8, path: '/serviceUser', name: '服务商人员管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  ]
                },
                {
                  path: '',
                  name: '日常运营',
                  isOpen: true,
                  icon: '/static/menuIcon/a_shuju.png',
                  lists: [
                    {id: 43, level1: 8, path: '/activityManagement', name: '活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  ]
                },
                {
                  path: '',
                  name: '小程序业务',
                  isOpen: true,
                  icon: '/static/menuIcon/a_shuju.png',
                  lists: [
                    {id: 46, level1: 8, path: '/userManagement', name: '注册用户', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                    {id: 47, level1: 8, path: '/projectSet', name: '项目设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  ]
                }
              ]
            }
          }
          this.menuList[1] = nav
          this.menuList[6] = nav1
          this.menuList[2] = nav2
          this.menuList[3] = nav3

          if (!isShow) {
            // 隐藏 SIM卡充值状态
            let lists = [
              {id: 13, level1: 3, path: '/SIPphone', name: '呼叫中心管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
              {id: 14, level1: 3, path: '/project', name: '项目管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
            ]
            // 系统管理 其他设置
            this.menuList[2].arr[1].lists = lists
          }
        }
        let obj = {
          id: 7,
          title: '系统日志',
          arr: [
            {
              path: '',
              name: '',
              isOpen: true,
              lists: [
                {id: 33, level1: 7, path: '/deviceFactoryReset', name: '设备出厂设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 34, level1: 7, path: '/deviceTest', name: '设备测试', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 35, level1: 7, path: '/padDevice', name: '信息终端', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 40, level1: 7, path: '/loginLog', name: '系统登录日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                {id: 52, level1: 7, path: '/exportLog', name: '系统导出日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
              ]
            }
          ]
        }
        if (role === 'superadmin') {
          this.menuList.push(obj)
        }
      } else if (role === 'csd') {
        this.menuList = [
          {
            id: 2,
            title: '处理中心',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                lists: [
                  {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          },
          {
            id: 6,
            title: '报表统计',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                icon: '',
                lists: [
                  {id: 25, level1: 6, path: '/alarmService', name: '事件统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '服务统计',
                isOpen: true,
                icon: '/static/menuIcon/hlfw.png',
                lists: [
                  {id: 26, level1: 6, path: '/serviceEvent', name: '服务日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
        ]
        if (urlLine === 'newjky.wecare-u.net' || urlLine === 'newhealth.wecare-u.net' || urlLine === 'kangnh.com' ||
          urlLine === 'kangnh.com' || urlLine === 'bengshan.kangnh.com') { // 上海更换
          let csd1 = {
            id: 2,
            title: '处理中心',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                lists: [
                  {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 3, level1: 2, path: '/customerService', name: '客服关爱', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 4, level1: 2, path: '/activeService', name: '发起服务', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          this.menuList[0] = csd1
        }
      } else if (role === 'op') {
        this.menuList = [
          {id: 1, path: '/monitor', title: '运营看板', arr: []},
          {
            id: 2,
            title: '处理中心',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                lists: [
                  {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          },
          {
            id: 8,
            title: '服务管理',
            arr: [
              {
                path: '',
                name: '服务订单',
                isOpen: true,
                icon: '/static/menuIcon/a_jichu.png',
                lists: [
                  {id: 2, level1: 8, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 39, level1: 8, path: '/examineOrder', name: '订单审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 50, level1: 8, path: '/servicePackage', name: '服务包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 51, level1: 8, path: '/serviceProjectBundle', name: '服务项目包', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '服务设置',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 37, level1: 8, path: '/supplierTypeService', name: '服务类型', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 38, level1: 8, path: '/supplierContent', name: '服务内容', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 9, level1: 8, path: '/supplierType', name: '服务商管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 11, level1: 8, path: '/serviceUser', name: '服务商人员管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '日常运营',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 43, level1: 8, path: '/activityManagement', name: '活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          },
          {
            id: 4,
            title: '数据管理',
            arr: [
              {
                path: '',
                name: '基础数据',
                isOpen: true,
                icon: '/static/menuIcon/a_jichu.png',
                lists: [
                  {id: 15, level1: 4, path: '/community', name: this.$store.state.user.moduletag === 3 ? '小区/机构管理' : '小区管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 16, level1: 4, path: '/homeManagement', name: this.$store.state.user.moduletag === 3 ? '家庭/房间管理' : '家庭管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 17, level1: 4, path: '/serviceObject', name: '服务对象管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '数据维护',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 18, level1: 4, path: '/checkData', name: '数据审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 41, level1: 4, path: '/chargeReminder', name: '费用管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          },
          {
            id: 5,
            title: '智慧物联',
            arr: [
              {
                path: '',
                name: '设备管理',
                isOpen: true,
                icon: '/static/menuIcon/a_guangli.png',
                lists: [
                  {id: 19, level1: 5, path: '/device', name: '监护设备', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 44, level1: 5, path: '/deviceStaff', name: '员工设备', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 45, level1: 5, path: '/deviceSupplier', name: '服务商人员设备', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '设备交互',
                isOpen: false,
                icon: '/static/menuIcon/a_jh.png',
                lists: [
                  {id: 20, level1: 5, path: '/deviceSet', name: '批量设置', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '',
                isOpen: true,
                icon: '',
                lists: [
                  {id: 23, level1: 5, path: '/healthData', name: '健康数据', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 24, level1: 5, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                  // {id: 42, level1: 5, path: '/safetyActivity', name: '消防活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  // {id: 43, level1: 5, path: '/activityManagement', name: '活动管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          },
          {
            id: 6,
            title: '报表统计',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                icon: '',
                lists: [
                  {id: 26, level1: 6, path: '/serviceEvent', name: '服务日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 25, level1: 6, path: '/alarmService', name: '事件统计', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
        ]
        if (urlLine === 'newjky.wecare-u.net' || urlLine === 'newhealth.wecare-u.net' || urlLine === 'kangnh.com' ||
          urlLine === 'kangnh.com' || urlLine === 'bengshan.kangnh.com') { // 上海更换 暂时不用 费用管理
          let op1 = {
            id: 2,
            title: '处理中心',
            arr: [
              {
                path: '',
                name: '',
                isOpen: true,
                lists: [
                  {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 3, level1: 2, path: '/customerService', name: '客服关爱', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 4, level1: 2, path: '/activeService', name: '发起服务', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          let bbc = {
            id: 4,
            title: '数据管理',
            arr: [
              {
                path: '',
                name: '基础数据',
                isOpen: true,
                icon: '/static/menuIcon/a_jichu.png',
                lists: [
                  {id: 15, level1: 4, path: '/community', name: this.$store.state.user.moduletag === 3 ? '小区/机构管理' : '小区管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 16, level1: 4, path: '/homeManagement', name: this.$store.state.user.moduletag === 3 ? '家庭/房间管理' : '家庭管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
                  {id: 17, level1: 4, path: '/serviceObject', name: '服务对象管理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              },
              {
                path: '',
                name: '数据维护',
                isOpen: true,
                icon: '/static/menuIcon/a_shuju.png',
                lists: [
                  {id: 18, level1: 4, path: '/checkData', name: '数据审核', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
          this.menuList[1] = op1
          this.menuList[3] = bbc
        }
      } else if (role === 'company') {
        this.menuList = [
          {
            id: 3,
            title: '系统管理',
            arr: [
              {
                path: '',
                name: '服务统计',
                isOpen: true,
                icon: '/static/menuIcon/a_fw.png',
                lists: [
                  {id: 26, level1: 6, path: '/serviceEvent', name: '服务日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          },
          {
            id: 8,
            title: '服务管理',
            arr: [
              {
                path: '',
                name: '服务订单',
                isOpen: true,
                icon: '/static/menuIcon/a_fuwu.png',
                lists: [
                  {id: 36, level1: 8, path: '/serviceOrder', name: '服务商接单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
                ]
              }
            ]
          }
        ]
      }
    },
    changeIndex (index) {
      this.indexActive = index
    },
    getChangeTab (arr) {
      if (this.$route.path === '/monitor') {
        this.indexActive = 1
        this.$store.commit('set_is_indexActive', this.indexActive)
      } else {
        this.indexActive = arr[0].lists[0].level1
        this.$store.commit('set_is_indexActive', this.indexActive)
      }
    },
    getLists () {
      let vm = this
      if (this.$route.path === '/monitor') {
        this.indexActive = 1
        this.$store.commit('set_is_indexActive', this.indexActive)
      }
      if (this.indexActive !== 1) {
        for (let i = 0; i < this.menuList.length; i++) {
          if (this.indexActive === this.menuList[i].id) {
            setTimeout(() => {
              vm.golobleObject.getChangeMenu(this.menuList[i], false)
            }, 300)
          }
        }
      }
    },
    clickMoney () {
      let obj = this.menuList[4]
      this.changeMenu(obj)
    },
    changeMenu (item) {
      if (item.id !== this.indexActive) {
        this.indexActive = item.id
        this.$store.commit('set_is_indexActive', this.indexActive)
        let path = false
        if (this.$route.path === '/monitor') { // 是否从 数据大屏 页面点击其他菜单 默认其他菜单第一个页面
          path = true
        }
        this.golobleObject.getChangeMenu(item, path)
      }
    }
  }
}
</script>

<style scoped>
.show-left{
  height: 60px;
  max-width: 500px;
  background: url("../../../assets/SHscreen/top_left.png") no-repeat right;
}
.show-right{
  flex: 1;
  background: url("../../../assets/SHscreen/top_right.png") no-repeat top;
}

.title-left{
  position: absolute;
  width: 400px;
}
.left-logo{
  width: 40px;
  height: 40px;
  vertical-align: middle;
}
.show-title{
  margin-left: 10px;
  width: 360px;
  color: #00CFFF;
  height: 50px;
  line-height: 46px;
  letter-spacing: 2px;
  font-size: 30px;
  text-align: center;
}
.nav-right-list{
  position: absolute;
  left: 400px;
  width: calc(100% - 600px);
  height: 45px;
  margin-top: -3px;
}
.item-nav{
  height: 54px;
  line-height: 54px;
  font-size: 16px;
  color: #00CFFF;
  cursor: pointer;
  float: left;
  width: 120px;
  text-align: center;
}
.active-select{
  background: url("../../../assets/navbar/gaoguang.png") no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
}
.text-color{
  font-family: CustomFont;
  background: -webkit-linear-gradient(#ffffff, #00CFFF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/childNavBar/jujiaNav.vue